import React from 'react'
import classnames from 'classnames'

import styles from './styles.css'

const Answer = () => (
  <div>
    <p className={classnames(styles.text, styles.section)}>
      This form is intended to allow you to capture thoughts, and more specifically in this case,
      the unpleasant or irrational thoughts that hinder us in a variety of ways. These can be
      negative self-talk that may go unnoticed--even though subconsciously it may be driving our
      behavior and mood, and the more conscious thoughts such as interpretations, assumptions,
      opinions, and judgments, that we experience as we go through our day.
    </p>
    <p className={classnames(styles.text, styles.section)}>
      Our suggested method for handling thoughts is the <span className={styles.bold}>Mindfulness @Work 5-Step Formula*</span> which involves:
    </p>

    <p className={classnames(styles.section)}>
      <p className={styles.text}>1. Labeling</p>
      <p className={styles.text}>2. Ranking</p>
      <p className={styles.text}>3. Accepting</p>
      <p className={styles.text}>4. Reframing</p>
      <p className={styles.text}>5. Refocusing</p>
    </p>

    <table className={classnames(styles.section)}>
      <tr>
        <td className={classnames(styles.text, styles.label, styles.tableData)}>Labeling</td>
        <td className={classnames(styles.text, styles.tableData)}>Pausing for a brief mindful moment, acknowledging the thought, and putting it into a simple statement that captures its essence. For instance, as we start to work on a difficult task, we may notice this intense negative self-talk telling us “you’re not good at this” and hindering our ability to focus and do our work. This would be the label for this thought: “You’re not good at this.”</td>
      </tr>
      <tr>
        <td className={classnames(styles.text, styles.label, styles.tableData)}>Ranking</td>
        <td className={classnames(styles.text, styles.tableData)}>Ranking the event surrounding the thought between 1 and 10 where 1 would be the most tragic thing that can happen and 10 being the happiest best thing that can happen and then all shades in between.</td>
      </tr>
      <tr>
        <td className={classnames(styles.text, styles.label, styles.tableData)}>Accepting</td>
        <td className={classnames(styles.text, styles.tableData)}>This would be accepting the fact that we are having this thought instead of denying it, suppressing it, or scolding ourselves for having it--all of which would lead to further negativity. Similar to what we introduced when dealing with emotions, ask the question: “What would it be like if I were to let this thought ‘be’ for now and be curious about it?” It doesn’t mean we have to like it or act on it. It is just stepping back for a bit and giving ourselves the opportunity to be an observer of the thought instead of a victim of it.</td>
      </tr>
      <tr>
        <td className={classnames(styles.text, styles.label, styles.tableData)}>Reframing</td>
        <td className={classnames(styles.text, styles.tableData)}>This consists of asking the question: “What can I learn from this thought?” and if applicable and feasible, replace the unrealistic thought with a more realistic one. For instance, reframing “I am not good at this” to “I find this task challenging but I will be able to manage through it” potentially drawing on a previous experience where you did manage through a similarly difficult task.</td>
      </tr>
      <tr>
        <td className={classnames(styles.text, styles.label, styles.tableData)}>Refocusing</td>
        <td className={classnames(styles.text, styles.tableData)}>This step consists of bringing our attention back to where we want to be which depends on the context we are in. If we were working on a task when we experienced the thought, it is time to go back and focus on the actual task. If we are having a conversation with someone, it would be focusing on that conversation.</td>
      </tr>
    </table>

    <p className={classnames(styles.text, styles.section)}>
      <span className={styles.bold}>Capturing thoughts in this form</span>
    </p>
    <p className={classnames(styles.text, styles.section)}>
      <span className={styles.bold}>Thought field:</span> This is where you jot down a brief description of the thought.
    </p>
    <p className={classnames(styles.text, styles.section)}>
      <span className={styles.bold}>Rank field:</span> This is where you rank the thought (see ranking details above).
    </p>
    <p className={classnames(styles.text, styles.section)}>
      <span className={styles.bold}>Reflection field:</span> This is where you would pause and conduct steps 3, 4, and 5 if needed, and jot down some insights from these steps (see more details about these steps above).
    </p>
    <p className={classnames(styles.text, styles.section)}>
      You can later review the various thoughts and reflections that you captured in the Log Page, so you can have your “mega” reflection and deeper insights over time.
    </p>

    <p className={classnames(styles.text, styles.section)}>
      <span className={styles.bold}>How about positive thoughts?</span>
    </p>
    <p className={classnames(styles.text, styles.section)}>
      We encourage you to capture them as well. If they are related to the actual task, you can use the Engagement Tab in the + Form. Otherwise, you can capture them in the Thoughts Tab and rank them positively on the scale:)
    </p>
    <p className={classnames(styles.text, styles.section, styles.italic)}>
      *Learn more about the <a className={styles.link} target="_blank" href="https://www.people-onthego.com/mindfulness-at-work">Mindfulness @Work Workshop</a> and Webinar as an additional resource to help you deepen the various habits we are working on in the 21-Day Challenge.
    </p>
  </div>
)

export default Answer



// WEBPACK FOOTER //
// ./src/components/categoryTabs/thoughtsForm/answer/index.js